import { createSlice } from '@reduxjs/toolkit'

import { getLinks } from '../actions/link'

type LinksState = {
  links: Links[];
  loading: boolean;
  error: boolean;
};

const initialState: LinksState = {
  links: [],
  loading: false,
  error: false,
}

const linkSlice = createSlice({
  name: 'links',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLinks.fulfilled, (state, action) => {
        state.links = action.payload
        state.loading = false
      })
      .addCase(getLinks.pending, (state) => {
        state.loading = true
        state.error = false
      })
      .addCase(getLinks.rejected, (state) => {
        state.error = true
        state.loading = false
      })
  },
})

export default linkSlice.reducer
